import {VoidFn} from '../../../types/common/functions/VoidFn';

export const CachedCleaners: Record<symbol, VoidFn> = {};